import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnDestroy {
  forgotPasswordForm!: FormGroup;
  message = '';
  success = false;
  submitted = false;
  pending = false;
  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService
  ) {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  reset() {
    this.message = '';
    this.success = false;
    this.submitted = true;

    if (this.forgotPasswordForm.valid) {
      this.pending = true;
      this.userService
        .forgotPassword(this.forgotPasswordForm.get('email')?.value)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            this.pending = false;
            console.log(response);
            //if (response.status >= 200 && response.status < 400) {
            this.success = true;
            this.message =
              'Success! Check your email for instructions to reset your password.';
            //}
          },
          error: (error) => {
            this.pending = false;
            this.message =
              'There was an issue. Please make sure you entered the correct email address.';
          },
        });
    } else {
      this.message = 'Invalid Form, please provide the data.';
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
